import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 3082F9ED-7ADE-491E-9FA5-39BC937D1F95
 * name swap-horizontal-bold
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/swap-horizontal-bold.svg
 * tags
 * - Arrow 
 */
export const SwapHorizontalBoldIcon = createSvgIcon(<><path d="M8,10V13H14V18H8V21L2,15.5L8,10M22,8.5L16,3V6H10V11H16V14L22,8.5Z" /></>, 'SwapHorizontalBoldIcon');
export default SwapHorizontalBoldIcon